
import { OrdersKeys } from '@/i18n/types/orders.types';

export const orders: Record<OrdersKeys, string> = {
  orders: 'Órdenes',
  myOrders: 'Mis Órdenes',
  orderNumber: 'Orden #',
  orderDate: 'Fecha de Orden',
  orderStatus: 'Estado',
  orderTotal: 'Total',
  products: 'Productos',
  quantity: 'Cantidad',
  price: 'Precio',
  viewDetails: 'Ver Detalles',
  noOrders: 'No hay Órdenes',
  noOrdersMessage: 'Aún no has realizado ninguna orden. Comienza a comprar para ver tus órdenes aquí.',
  goShopping: 'Ir de Compras',
  loadingOrders: 'Cargando tus órdenes...',
  paid: 'Pagado',
  pending: 'Pendiente',
  failed: 'Fallido',
  cancelled: 'Cancelado',
  processing: 'Procesando',
  shipped: 'Enviado',
  delivered: 'Entregado',
  orderItems: 'Artículos de la Orden',
  subtotal: 'Subtotal',
  total: 'Total',
  paymentMethod: 'Método de Pago',
  shippingAddress: 'Dirección de Envío',
  billingAddress: 'Dirección de Facturación',
  orderSummary: 'Resumen de la Orden',
  backToOrders: 'Volver a Órdenes',
  downloadInvoice: 'Descargar Factura',
  trackOrder: 'Rastrear Orden',
  contactSupport: 'Contactar Soporte',
  orderNotFound: 'Orden no encontrada',
  errorLoadingOrder: 'Error al cargar detalles de la orden',
  refreshPage: 'Por favor actualiza la página e intenta de nuevo',
};
